// AdminListingsPage.jsx

import React, { useEffect, useState } from 'react';
import { Box, Typography, TextField, Button, Card, CardContent, CardMedia, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { fetchListings, deleteListingById } from '../../services/ListingService';
import AdminListingsPageStyles from './AdminListingsPage.styles';

const AdminListingsPage = () => {
  const [listings, setListings] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch all listings on component mount
    const loadListings = async () => {
      try {
        const data = await fetchListings();
        setListings(data);
      } catch (error) {
        console.error('Failed to load listings', error);
      }
    };
    loadListings();
  }, []);

  const handleDelete = async (listingId) => {
    if (window.confirm('Are you sure you want to delete this listing? This action cannot be undone.')) {
      try {
        await deleteListingById(listingId);
        setListings(listings.filter((listing) => listing.id !== listingId));
      } catch (error) {
        console.error('Failed to delete listing', error);
      }
    }
  };

  const filteredListings = listings.filter((listing) =>
    listing.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleEdit = (listingId) => {
    navigate(`/edit-listing/${listingId}`);
  };

  return (
    <Box sx={AdminListingsPageStyles.container}>
      <Typography variant="h4" sx={AdminListingsPageStyles.title}>
        Manage Listings
      </Typography>
      <TextField
        label="Search Listings"
        fullWidth
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        sx={AdminListingsPageStyles.searchField}
        placeholder="Search by title"
      />
      <Grid container spacing={3} sx={{ marginTop: '1rem' }}>
        {filteredListings.map((listing) => (
          <Grid item xs={12} sm={6} md={4} key={listing.id}>
            <Card sx={AdminListingsPageStyles.card}>
              <CardMedia
                component="img"
                height="140"
                image={listing.image}
                alt={listing.title}
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  {listing.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {listing.location} - {listing.price}
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: '1rem' }}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => handleEdit(listing.id)}
                    sx={AdminListingsPageStyles.editButton}
                  >
                    Edit
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => handleDelete(listing.id)}
                    sx={AdminListingsPageStyles.deleteButton}
                  >
                    Delete
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default AdminListingsPage;
